import { render, staticRenderFns } from "./TeacherPaymentDialog.vue?vue&type=template&id=10f2dd2b&"
import script from "./TeacherPaymentDialog.vue?vue&type=script&lang=ts&"
export * from "./TeacherPaymentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports